enum FinancingOptionDataSourceEnum {
	disabled = 'disabled',
	oneWeb = 'OneWeb'
}

export default FinancingOptionDataSourceEnum;
